(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jt-description-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jt-description-preview')) {
    customElements.define('jt-description-preview', class extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('.jt-description-preview__content');
        this.button = this.querySelector('.jt-description-preview__toggle');
        if (!this.content || !this.button) return;
        this.expanded = false;
        this.toggle = () => {
          this.expanded = !this.expanded;
          this.measure();
        };
        this.button.addEventListener('click', this.toggle);
        this.observer = new ResizeObserver(() => this.measure());
        this.observer.observe(this.content);
        this.measure();
        document.fonts.ready.then(() => {
          if (this.isConnected) this.measure();
        });
      }
      measure() {
        const style = getComputedStyle(this.content);
        const lineHeight = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.6;
        const previewHeight = lineHeight * 7;
        this.content.style.setProperty('--jt-description-preview-height', `${previewHeight}px`);
        const long = this.content.scrollHeight > previewHeight + 2;
        this.button.hidden = !long;
        this.classList.toggle('is-collapsed', long && !this.expanded);
        this.button.setAttribute('aria-expanded', String(this.expanded || !long));
        this.button.textContent = this.expanded ? this.button.dataset.collapse : this.button.dataset.expand;
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.button?.removeEventListener('click', this.toggle);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
